import { render, staticRenderFns } from "./PublicIp.vue?vue&type=template&id=0dc7a1cd&scoped=true"
import script from "./PublicIp.vue?vue&type=script&lang=js"
export * from "./PublicIp.vue?vue&type=script&lang=js"
import style0 from "./PublicIp.vue?vue&type=style&index=0&id=0dc7a1cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc7a1cd",
  null
  
)

export default component.exports